import { Box, Flex } from '@mantine/core'

import type { FlexInputWrapperProps } from '@/components/FlexInputWrapper/FlexInputWrapper.types'

export function FlexInputWrapper({
  isLast,
  leftInput,
  rightInput,
}: FlexInputWrapperProps) {
  const width = isLast ? '50%' : '100%'
  const marginRight = isLast ? 8 : 0

  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      gap={{ base: 0, md: 16 }}
      w={{ base: '100%', md: width }}
    >
      <Box flex={{ base: 1, md: '100%' }} mr={{ base: 0, md: marginRight }}>
        {leftInput}
      </Box>

      {rightInput && <Box flex={{ base: 1, md: '100%' }}>{rightInput}</Box>}
    </Flex>
  )
}
